import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'missionStatusClass' })
export class MissionStatusClassPipe implements PipeTransform {
    transform: (value: any, ...args: any[]) => string = (status: string) =>
        `mission-status-${status.toLowerCase()}`;
}
